<template>
  <div class="row justify-between items-center" :class="'title-' + row.level">
    <!-- 一级标题/二级标题 左侧部分 -->
    <div class="title-text">
      <span class="title-prefix"><slot /></span>
      <el-input :ref="editRef" size="small"
                v-if="row.editable"
                v-model="row.title"
                class="col"
                @click.stop.native @blur="closeEdit"
                placeholder="请输入章节名称" />
      <span v-else :title="row.title">{{ row.title }}</span>
    </div>

    <!-- 操作按钮 -->
    <div class="title-opt-btns row">
      <i v-if="row.level !== 3"
         class="el-icon-circle-plus-outline row-opt-btn cursor-pointer"
         title="添加章节"
         @click.stop="addTitle"></i>

      <i class="el-icon-edit row-opt-btn cursor-pointer" title="编辑标题" @click.stop="editTitle"></i>

      <el-popover v-model="showDeletePopover" width="auto" :title="`确定删除【${row.title}】章节吗?`">
        <div slot="reference">
          <i title="删除本章节" class="el-icon-delete row-opt-btn cursor-pointer"></i>
        </div>

        <div class="delete-tip">章节不足会导致论文总体字数不足。</div>
        <div class="delete-popconfirm-btns">
          <el-button size="mini" @click="cancel">取消</el-button>
          <el-button type="primary" size="mini" @click="deleteConfirm">确定</el-button>
        </div>
      </el-popover>

      <img @click.stop="setGraphData('flowchart')"
            :src="row.chartAndTable.includes('flowchart') ? chartActive : chartIcon"
            class="extend-icon cursor-pointer"
            title="图表"
            :class="{'extend-icon-active': row.chartAndTable.includes('flowchart')}"></img>

      <img @click.stop="setGraphData('table')"
           :src="row.chartAndTable.includes('table') ? tableActive : tableIcon"
           class="extend-icon cursor-pointer"
           title="表格"
           :class="{'extend-icon-active': row.chartAndTable.includes('table')}"></img>

      <img @click.stop="setGraphData('code')"
           :src="row.chartAndTable.includes('code') ? codeActive : codeIcon"
           class="extend-icon cursor-pointer"
           title="代码"
           :class="{'extend-icon-active': row.chartAndTable.includes('code')}"></img>
    </div>
  </div>
</template>

<script>
import chartActive from '@/assets/images/icon-chart.png'
import chartIcon from '@/assets/images/icon-chart2.png'
import tableActive from '@/assets/images/icon-table.png'
import tableIcon from '@/assets/images/icon-table2.png'
import codeActive from '@/assets/images/icon-code.png'
import codeIcon from '@/assets/images/icon-code2.png'
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    addNew: { // 添加子章节
      type: Function,
      required: false
    }
  },
  computed: {
    editRef () { // input节点ref
      return 'input_' + this.row.id
    }
  },
  data () {
    return {
      chartActive,
      chartIcon,
      tableActive,
      tableIcon,
      codeActive,
      codeIcon,

      showDeletePopover: false // 是否显示删除提示框
    }
  },
  watch: {
    'row.editable': {
      immediate: true,
      handler (val) {
        if (val) {
          this.focusTitle()
        }
      }
    }
  },
  methods: {
    addTitle () {
      typeof this.addNew === 'function' && this.addNew(this.row)
    },
    editTitle () { // 点击编辑按钮：标题变为可编辑状态；聚焦到编辑框
      this.row.editable = true
      this.focusTitle()
    },
    focusTitle () { // 聚焦到input
      this.$nextTick(() => {
        this.$refs[this.editRef] && this.$refs[this.editRef].focus()
      })
    },
    closeEdit () { // 关闭编辑状态
      this.row.editable = false
    },
    deleteConfirm () { // 删除章节
      this.cancel()
      this.$emit('delete-row', this.row)
    },
    setGraphData (key) {
      const index = this.row.chartAndTable.indexOf(key)
      index === -1 ? this.row.chartAndTable.push(key) : this.row.chartAndTable.splice(index, 1)
    },
    cancel () {
      this.showDeletePopover = false
    }
  }
}
</script>

<style lang="less" scoped>
.title-text {
  flex: 10000 1 0%;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.title-prefix {
  margin-right: 8px;
}
.title-1 {
  font-size: 14px;
  font-weight: 700;
  background-color: #fafafa;
  padding: 8px 10px 8px 10px;
  &.title-1 {
    margin-bottom: 8px;
  }
}
.title-2 {
  font-size: 13px;
  padding: 8px 10px 8px 16px;
  &:hover {
    background-color: #f3f4f6;
  }
}
.title-3 {
  font-size: 13px;
  padding: 8px 10px 8px 24px;
}
.title-1, .title-2, .title-3 {
  color: #1f2225;
  border-radius: 6px;
  &:hover {
    background-color: #f3f4f6;
  }
  .title-ellipse {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.title-opt-btns {
  margin-left: 20px;
  @media screen and (max-width: 900px) {
    margin-left: 0;
    width: 100%;
  }
  .row-opt-btn {
    line-height: 24px;
    color: #a4a4a4;
    font-size: 16px;
    margin-right: 10px;
  }
  .extend-icon {
    width: 24px;
    height: 24px;
    border: 1px solid transparent;
    border-radius: 50%;
    &:hover {
      border-color: #a4a4a4;
    }
  }
  .extend-icon-active {
    background-color: #409EFF;
  }
}

.delete-tip {
  text-align: left;
  margin-left: 20px;
  margin-top: -6px;
}
.delete-popconfirm-btns {
  margin-top: 16px;
  text-align: right;
}
</style>